module.exports = __webpack_public_path__ + "img/banner.dfd50e74.png";